"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _defer = _interopRequireDefault(require("draft-plugins/lib/defer"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _TeamInvitationForm = _interopRequireDefault(require("./invitation/TeamInvitationForm"));

var ADD_TOKEN_ON_INVITATION_DELAY = 600;

var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$provisioning = _ref.provisioning,
      provisioning = _ref$provisioning === void 0 ? {} : _ref$provisioning,
      _ref$onShown = _ref.onShown,
      onShown = _ref$onShown === void 0 ? function () {} : _ref$onShown,
      _ref$onRemoved = _ref.onRemoved,
      onRemoved = _ref$onRemoved === void 0 ? function () {} : _ref$onRemoved,
      _ref$onInviteSuccess = _ref.onInviteSuccess,
      onInviteSuccess = _ref$onInviteSuccess === void 0 ? function () {} : _ref$onInviteSuccess,
      _ref$onInviteFailure = _ref.onInviteFailure,
      onInviteFailure = _ref$onInviteFailure === void 0 ? function () {} : _ref$onInviteFailure,
      _ref$validate = _ref.validate,
      validate = _ref$validate === void 0 ? function () {
    // Return null if no error exists.
    // Return an error string if an error does exist.
    // Example error: "User already exists on portal."
    return null;
  } : _ref$validate;

  return (0, _createReactClass.default)({
    propTypes: {
      onSelect: _propTypes.default.func.isRequired,
      onCancel: _propTypes.default.func.isRequired,
      search: _propTypes.default.string.isRequired,
      toggleForcedOverlayFocus: _propTypes.default.func.isRequired
    },
    componentDidMount: function componentDidMount() {
      var toggleForcedOverlayFocus = this.props.toggleForcedOverlayFocus;
      toggleForcedOverlayFocus(true);
      (0, _defer.default)(onShown);
    },
    componentWillUnmount: function componentWillUnmount() {
      var toggleForcedOverlayFocus = this.props.toggleForcedOverlayFocus;
      toggleForcedOverlayFocus(false);
      (0, _defer.default)(onRemoved);
    },
    handleUserInvited: function handleUserInvited(inviteeEmail) {
      onInviteSuccess(inviteeEmail);
      setTimeout((0, _partial.default)(this.handleAddToken, inviteeEmail), ADD_TOKEN_ON_INVITATION_DELAY);
    },
    handleAddToken: function handleAddToken() {
      var _this$props = this.props,
          search = _this$props.search,
          onSelect = _this$props.onSelect; // Does not include a value since there
      // is no owner id yet for the invited user.

      onSelect({
        text: search
      });
    },
    render: function render() {
      return _react.default.createElement("div", {
        ref: "zeroState",
        className: "at-mention-zero-state"
      }, _react.default.createElement(_TeamInvitationForm.default, {
        search: this.props.search,
        validate: validate,
        provisioning: provisioning,
        onCancel: this.props.onCancel,
        onInvited: this.handleUserInvited,
        onInviteFailed: onInviteFailure,
        toggleForcedOverlayFocus: this.props.toggleForcedOverlayFocus
      }));
    }
  });
};

exports.default = _default;
module.exports = exports.default;